export const MARGINS = {
  SIDE: 18
}
